"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ThemeProvider_1 = require("./lib/ThemeProvider");
var id_1 = require("tsafe/id");
var useGuaranteedMemo_1 = require("powerhooks/useGuaranteedMemo");
var Button_1 = __importDefault(require("@mui/material/Button"));
var capitalize_1 = require("tsafe/capitalize");
var tsafe_1 = require("tsafe");
var breakpoints_1 = require("./lib/breakpoints");
var typography_1 = require("./lib/typography");
var pxToNumber_1 = require("./tools/pxToNumber");
var useCallbackFactory_1 = require("powerhooks/useCallbackFactory");
var runExclusive = __importStar(require("run-exclusive"));
function createButton(params) {
    var _this = this;
    var Icon = (params !== null && params !== void 0 ? params : {
        "Icon": id_1.id(function () { return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, {}, void 0); }),
    }).Icon;
    var Button = react_1.memo(react_1.forwardRef(function (props, ref) {
        var className = props.className, _a = props.variant, variant = _a === void 0 ? "primary" : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, children = props.children, startIcon = props.startIcon, endIcon = props.endIcon, _c = props.autoFocus, autoFocus = _c === void 0 ? false : _c, tabIndex = props.tabIndex, name = props.name, htmlId = props.htmlId, ariaLabel = props["aria-label"], 
        //For the forwarding, rest should be empty (typewise)
        rest = __rest(props, ["className", "variant", "disabled", "children", "startIcon", "endIcon", "autoFocus", "tabIndex", "name", "htmlId", "aria-label"]);
        var _d = __read(react_1.useState(false), 2), isMouseIn = _d[0], setIsMouseIn = _d[1];
        var handleMousePositionFactory = useCallbackFactory_1.useCallbackFactory(runExclusive.build(function (_a) {
            var _b = __read(_a, 1), position = _b[0];
            return __awaiter(_this, void 0, void 0, function () {
                var _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _c = position;
                            switch (_c) {
                                case "in": return [3 /*break*/, 1];
                                case "out": return [3 /*break*/, 2];
                            }
                            return [3 /*break*/, 4];
                        case 1:
                            setIsMouseIn(true);
                            return [2 /*return*/];
                        case 2: return [4 /*yield*/, new Promise(function (resolve) {
                                return setTimeout(resolve, 400);
                            })];
                        case 3:
                            _d.sent();
                            setIsMouseIn(false);
                            _d.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }));
        var _e = useStyles({
            variant: variant,
            disabled: disabled,
            isMouseIn: isMouseIn,
        }), classes = _e.classes, cx = _e.cx;
        var IconWd = useGuaranteedMemo_1.useGuaranteedMemo(function () { return function (props) {
            return (jsx_runtime_1.jsx(Icon, { iconId: props.iconId, className: classes.icon, size: "default" }, void 0));
        }; }, [disabled, classes.icon]);
        return (jsx_runtime_1.jsx(Button_1.default, __assign({ onMouseEnter: handleMousePositionFactory("in"), onMouseLeave: handleMousePositionFactory("out"), ref: ref, className: cx(classes.root, className), 
            //There is an error in @mui/material types, this should be correct.
            disabled: disabled, startIcon: startIcon === undefined ? undefined : (jsx_runtime_1.jsx(IconWd, { iconId: startIcon }, void 0)), endIcon: endIcon === undefined ? undefined : (jsx_runtime_1.jsx(IconWd, { iconId: endIcon }, void 0)), autoFocus: autoFocus, tabIndex: tabIndex, name: name, id: htmlId, "aria-label": ariaLabel }, (function () {
            if ("type" in rest) {
                var type = rest.type, restRest_1 = __rest(rest, ["type"]);
                //For the forwarding, rest should be empty (typewise),
                tsafe_1.assert();
                return __assign({ type: type }, restRest_1);
            }
            var onClick = rest.onClick, href = rest.href, _a = rest.doOpenNewTabIfHref, doOpenNewTabIfHref = _a === void 0 ? href !== undefined : _a, restRest = __rest(rest, ["onClick", "href", "doOpenNewTabIfHref"]);
            return __assign({ onClick: onClick,
                href: href, "target": doOpenNewTabIfHref ? "_blank" : undefined }, restRest);
        })(), { children: typeof children === "string"
                ? capitalize_1.capitalize(children)
                : children }), void 0));
    }));
    var useStyles = ThemeProvider_1.makeStyles({ "name": { Button: Button } })(function (theme, _a) {
        var variant = _a.variant, disabled = _a.disabled, isMouseIn = _a.isMouseIn;
        var textColor = theme.colors.useCases.typography[disabled
            ? "textDisabled"
            : (function () {
                switch (variant) {
                    case "primary":
                        return "textFocus";
                    case "secondary":
                    case "ternary":
                        return "textPrimary";
                }
            })()];
        var hoverTextColor = (function () {
            switch (theme.isDarkModeEnabled) {
                case true:
                    return theme.colors.palette[(function () {
                        switch (variant) {
                            case "primary":
                                return "light";
                            case "secondary":
                            case "ternary":
                                return "dark";
                        }
                    })()].main;
                case false:
                    return theme.colors.palette.light.main;
            }
        })();
        return {
            "root": (function () {
                var hoverBackgroundColor = theme.colors.useCases.buttons[(function () {
                    switch (variant) {
                        case "primary":
                            return "actionHoverPrimary";
                        case "secondary":
                        case "ternary":
                            return "actionHoverSecondary";
                    }
                })()];
                var paddingSpacingTopBottom = 2;
                var borderWidth = (function () {
                    switch (variant) {
                        case "primary":
                        case "secondary":
                            return 2;
                        case "ternary":
                            return 0;
                    }
                })();
                var approxHeight = 2 * theme.spacing(paddingSpacingTopBottom) +
                    2 * borderWidth +
                    pxToNumber_1.pxToNumber(theme.typography.variants[typography_1.variantNameUsedForMuiButton]
                        .style.lineHeight);
                return __assign(__assign(__assign({ "textTransform": "unset", "backgroundColor": disabled
                        ? theme.colors.useCases.buttons.actionDisabledBackground
                        : (function () {
                            switch (variant) {
                                case "primary":
                                case "secondary":
                                    return "transparent";
                                case "ternary":
                                    return theme.colors.useCases.surfaces
                                        .background;
                            }
                        })(), "borderRadius": approxHeight / 2, borderWidth: borderWidth, "borderStyle": "solid", "borderColor": disabled
                        ? "transparent"
                        : hoverBackgroundColor }, theme.spacing.topBottom("padding", paddingSpacingTopBottom)), theme.spacing.rightLeft("padding", (function () {
                    if (theme.windowInnerWidth >= breakpoints_1.breakpointsValues.xl) {
                        return 3;
                    }
                    return 4;
                })())), { "&.MuiButton-text": {
                        "color": textColor,
                    }, 
                    //NOTE: If the position of the button is relative (the default)
                    //it goes hover everything not positioned, we have to mess with z-index and
                    //we don't want that.
                    //The relative positioning is needed for the touch ripple effect.
                    //If we dont have position relative the effect is not restricted to the
                    //button: https://user-images.githubusercontent.com/6702424/157982515-c97dfa81-b09a-4323-beb9-d1e92e7ebe4d.mov
                    //The solution is set 'position: relative' only when the ripple effect is supposed to be visible.
                    //This explain the following awful rules.
                    //The expected result is: https://user-images.githubusercontent.com/6702424/157984062-27e544c3-f86f-47b8-b141-c5f61b8a2880.mov
                    //NOTE WILLIAM: In this example I set the position
                    //to relative when the mouse is inside the element.
                    //Before it was set when the element was active witch
                    //meant that the touch ripple effect would be suddenly
                    //interrupted when the mouse button goes up, witch
                    //was not very satisfying aesthetic wise.
                    //May it also be noted that I have used a parameter instead of
                    //:hover, because if we trigger the touch ripple effect and move the
                    //mouse outside the element before the effect has had time to
                    //finish, it produces the same unsatisfying interruption effect.
                    //So I set the parameter using an async function wrapped in
                    //a run exclusive, that delays the setting of the position slightly
                    //when the mouse moves outside the element.
                    "position": isMouseIn ? "relative" : "unset", "& .MuiTouchRipple-root": {
                        "display": isMouseIn ? "unset" : "none",
                    }, "&:hover": {
                        "backgroundColor": hoverBackgroundColor,
                        "& .MuiSvgIcon-root": {
                            "color": hoverTextColor,
                        },
                        "&.MuiButton-text": {
                            "color": hoverTextColor,
                        },
                    } });
            })(),
            "icon": {
                "color": textColor,
            },
        };
    });
    return { Button: Button };
}
exports.createButton = createButton;
//# sourceMappingURL=Button.js.map